import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { APIResults, AssemblyConfig } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-manage-destructive",
	templateUrl: "./manage-destructive.component.html",
	styleUrls: ["./manage-destructive.component.scss"]
})
export class ManageDestructiveComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;

	@Output()
	public AssetUpdated = new EventEmitter<APIResults.Asset>();

	public brand = BrandVars;

	public confirmOBCU: string;
	public confirmWipe: string;
	public confirmDelete: string;
	public resetAssetAuth: string;

	public assetOps: APIResults.Operation[] = null;
	public operationToDelete: APIResults.Operation = null;

	public componentList: AssemblyConfig.Component[] = null;
	public componentForAcq: AssemblyConfig.Component = null;
	public operationForAcq: APIResults.Operation = null;
	public dateForAcq: Date = null;
	public acquisitionList: APIResults.Acquisition[] = null;
	public acquisitionToDelete = null;

	public wipeStatus: string;
	public wipeProgress: number;

	constructor(private api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		await Promise.all([
			this.RefreshAssetOps(),
			this.RefreshAssetComponents(),
		]);
	}

	private async RefreshAssetOps() {
		this.assetOps = [];
		this.operationToDelete = null;
		this.assetOps = await this.api.GetOperations(this.asset.asset_id, 1600, true);
	}

	private async RefreshAssetComponents() {
		this.componentList = null;
		this.componentList = await this.api.GetAllComponents(this.asset.asset_id);
	}

	public async ResetAuth() {
		if (this.confirmOBCU !== this.asset.obcu_serial_number) {
			throw new Error("Server ID confirmation does not match");
		}
		this.resetAssetAuth = undefined;
		const result = await this.api.ResetAsset(this.asset.asset_id);
		this.AssetUpdated.emit(this.asset);
		this.resetAssetAuth = result.auth;
	}

	public async ListAcquisitions() {
		this.acquisitionToDelete = null;
		this.acquisitionList = null;
		if (this.operationForAcq && this.componentForAcq) {
			this.acquisitionList = await this.api.GetOperationAcquisitions(this.operationForAcq.operation_id, this.componentForAcq.id);
		} else if (this.dateForAcq && this.componentForAcq) {
			this.acquisitionList = await this.api.GetOperationAcquisitions(this.assetOps[0].operation_id, this.componentForAcq.id, this.dateForAcq);
		}
	}

	public async DeleteAcquisition() {
		if (this.confirmOBCU !== this.asset.obcu_serial_number) {
			throw new Error("Server ID confirmation does not match");
		}
		await this.api.DeleteAcquisition(this.acquisitionToDelete.acquisition_id);
		await this.ListAcquisitions();
	}

	public async DeleteOperation() {
		if (this.confirmOBCU !== this.asset.obcu_serial_number) {
			throw new Error("Server ID confirmation does not match");
		}
		await this.api.DeleteOperation(this.asset.asset_id, this.operationToDelete.operation_id);
		await this.RefreshAssetOps();
	}

	public async WipeAsset() {
		if (this.confirmOBCU !== this.asset.obcu_serial_number) {
			throw new Error("Server ID confirmation does not match");
		}

		const result = await this.api.WipeAsset(this.asset.asset_id);
		const taskId = result.task;
		await this.api.PollTaskToCompletion(taskId, (status, progress) => {
			this.wipeStatus = status;
			this.wipeProgress = progress;
		});
	}

	public async DeleteAsset() {
		if (this.confirmOBCU !== this.asset.obcu_serial_number) {
			throw new Error("Server ID confirmation does not match");
		}
		await this.api.DeleteAsset(this.asset.asset_id);
		this.AssetUpdated.emit(undefined);
	}
}
